import './HelpBreadcrumbs.css';

export default function HelpBreadcrumbs({ category, article, onHomeClick }) {
  return (
    <nav className="help-breadcrumbs" aria-label="Help breadcrumbs">
      <button type="button" className="help-breadcrumbs-link" onClick={onHomeClick}>
        Home
      </button>
      <span className="help-breadcrumbs-separator">/</span>
      <span className="help-breadcrumbs-current">{category}</span>
      <span className="help-breadcrumbs-separator">/</span>
      <span className="help-breadcrumbs-current">{article}</span>
    </nav>
  );
}
